import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const menuStyle = () => theme => css`
  min-width: ${rem(232)};
  color: ${theme.color.monochrome.black};
  border-radius: ${rem(8)};
  font-size: ${theme.fontSize.large};

  [role='menuitem'] {
    .item-icon {
      background-color: ${theme.color.monochrome.superLight};
    }
    &[tabindex='0']:hover,
    &.highlighted {
      background-color: ${theme.color.monochrome.superLight} !important;
      .item-icon {
        background-color: ${theme.color.monochrome.white};
      }
    }
  }
`

export const styles = {
  menuStyle,
}
